import React, { useEffect, useState } from "react";
import lock from "../../assets/lock.svg";
import unlock from "../../assets/unlock.svg";
import Sidebar from "../../components/Sidebar";
import OvenPlayer from "ovenplayer";
import { adapterConfig } from "../../requests/adapterConfig";
import { fetchAdapters } from "../../requests/fetchAdapters";
import { fetchParams } from "../../requests/fetchParams";
import { scan } from "../../requests/scan"
import StatusAlert, { StatusAlertService } from 'react-status-alert'
import 'react-status-alert/dist/status-alert.css'
import satDish from "../../assets/satellite-dish.svg";
import arrow from "../../assets/arrow.png"
import { data } from "react-router-dom";

function Home() {
    const [lockedUi, setLockedUi] = useState(true);
    const [players, setPlayers] = useState([]);
    const [adapters, setAdapters] = useState([]);
    const [editedAdapters, setEditedAdapters] = useState([]);
    const [isAdaptersLoaded, setAdaptersLoaded] = useState(false);
    const [webSocket, setWebSocket] = useState(null);
    const [wsStreams, setWsStreams] = useState(null);
    const [polarizationOptions, setPolarizationOptions] = useState([
        { label: "V", selected: true },
        { label: "H", selected: false }])

    const [params, setParams] = useState([])
    const [scanShown, setScanShown] = useState(false)
    const [scanResults, setScanResults] = useState({
        data: [],
        loaded: false,
        step: "pending",
    })

    async function getParams() {
        let response = await fetchParams()
        let params = await response.json()
        console.log(params)
        setParams(params)
    }
    async function getScanResults(adapterId, sid) {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId
                    ? { ...adapter, scanResults: { ...adapter.scanResults, step: 'scanning' } }
                    : adapter
            )
        );
        //setScanResults((prev) => ({ ...prev, step: "scanning" }))
        let tries = 3
        let data = []
        let succeed = false
        for (let i = 1; i <= tries; i++) {
            let response = await scan(adapterId,sid)
            let results = await response.json()
            console.log(i, results)
            if (results.programs != undefined && results.programs.length > 0) {
                data = results.programs
                succeed = true
                break
            }
        }
        if (!succeed) {
            showWarningAlert("Not found any programs on frequency.")
            setAdapters((prevAdapters) =>
                prevAdapters.map((adapter) =>
                    adapter.id === adapterId
                        ? { ...adapter, scanResults: {}, scanShown: false }
                        : adapter
                )
            );
        } else {
            setAdapters((prevAdapters) =>
                prevAdapters.map((adapter) =>
                    adapter.id === adapterId
                        ? { ...adapter, scanResults: { ...adapter.scanResults, step: 'done', loaded: true, data: data } }
                        : adapter
                )
            );
        }

        //setScanResults((prev) => ({ ...prev, step: "done", data: results.programs, loaded: true }))
    }
    function playerFactory(id, url) {
        try {
            const player = OvenPlayer.create(id, {

                "autoStart": true,
                "autoFallback": true,
                "mute": false,
                "sources": [{
                    "label": "Preview",
                    "type": "hls",
                    "file": url
                }]
            });
            player.play();
            player.on('error', (error) => handlePlayerError(player, url, error, id))
            player.on('complete', (error) => handlePlayerError(player, url, error, id))

            setPlayers(prevState => [...prevState, player]);

            return player;
        } catch (err) {
            console.log(err)
        }
    }
    function handlePlayerError(player, url, error, id) {
        console.log("Error on player: " + id)
        setTimeout(() => {
            player.remove()
            playerFactory(id, url)
            setPlayers(prevState => [...prevState, player]);
        }, 4000);
    }
    async function getAdapters() {
        try {
            // 1. Получаем и сортируем адаптеры
            const response = await fetchAdapters();
            const { adapters } = await response.json();

            adapters.sort((a, b) => a.name.localeCompare(b.name));

            const updatedAdapters = adapters.map((adapter) => {
                console.log(adapter.name, adapter.streams)
                const multicastMatch = adapter.streams[0]?.output[0]?.match(/@([\d.]+:\d+)/);
                return {
                    ...adapter,
                    mcastOut: multicastMatch?.[1] || null,
                    lockedUi: true
                };
            });

            setAdapters(updatedAdapters);
            setAdaptersLoaded(true);

            // 2. Устанавливаем WebSocket для lock-статуса адаптеров
            const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
            const host = window.location.host;
            //const host = "127.0.0.1:8080"
            const wsAdapters = new WebSocket(`${protocol}//${host}/api/adapters/status/ws`);
            setWebSocket(wsAdapters);

            wsAdapters.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    if (!Array.isArray(data)) return;

                    const lockMap = data.reduce((acc, item) => {
                        acc[item.adapterId] = item.lock;
                        return acc;
                    }, {});

                    setAdapters((prev) =>
                        prev.map((adapter) => ({
                            ...adapter,
                            lock: lockMap[adapter.id] || 0,
                            isPulsating: true
                        }))
                    );

                    setTimeout(() => {
                        setAdapters((prev) =>
                            prev.map((adapter) => ({
                                ...adapter,
                                isPulsating: false
                            }))
                        );
                    }, 1000);
                } catch (err) { }
            };

            // 3. Устанавливаем WebSocket для потоков (битрейт, onair и т.д.)
            const wsStreams = new WebSocket(`${protocol}//${host}/api/streams/status/ws`);
            setWsStreams(wsStreams);

            wsStreams.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    if (!Array.isArray(data)) return;

                    setAdapters((prev) =>
                        prev.map((adapter) => {
                            const match = data.find((s) => s.streamId === adapter.streams[0]?.streamId);
                            if (!match) return adapter;

                            return {
                                ...adapter,
                                streams: [
                                    {
                                        ...adapter.streams[0],
                                        onair: match.onair,
                                        bitrate: match.bitrate,
                                        scrambled: match.scrambled
                                    },
                                    ...adapter.streams.slice(1)
                                ]
                            };
                        })
                    );

                    setTimeout(() => {
                        setAdapters((prev) =>
                            prev.map((adapter) => ({
                                ...adapter,
                                isPulsating: false
                            }))
                        );
                    }, 1000);
                } catch (err) { }
            };

            // 4. Возвращаем функцию очистки
            return () => {
                wsAdapters?.close();
                wsStreams?.close();
            };
        } catch (err) {
            console.error("Failed to get adapters:", err);
        }
    }

    function generatePlayers(adapters) {
        adapters.forEach((adapter) => {
            try {
                playerFactory(
                    adapter.id,
                    adapter.streams[0].webRTC
                    //"http://10.7.31.103/228.8.8.93:1234/playlist.m3u8"
                );
            } catch (e) {
                console.error(e);
            }

        });
    }
    useEffect(() => {
        setTimeout(generatePlayers(adapters), 1000)
    }, [isAdaptersLoaded]);
    useEffect(() => {
        try {
            getAdapters();
            getParams();

        }
        catch (e) {
            console.log(e)
        }
    }, []);
    const handleUnlockUI = (adapterId) => {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId ? { ...adapter, lockedUi: false } : adapter
            )
        );
    };
    const handleLockUI = (adapterId) => {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId ? { ...adapter, lockedUi: true } : adapter
            )
        );
    };
    const handleSave = async (adapter) => {
        if (validateBISSKey(adapter.streams[0].bissKey)) {
            if (adapter.frequency < 950) {
                showWarningAlert("Invalid frequency.")
                return
            }
            if (adapter.frequency > 40000) {
                showWarningAlert("Invalid frequency.")
                return
            }
            if (adapter.frequency === "") {
                showWarningAlert("Invalid frequency.")
                return
            }
            if (adapter.symbolrate > 50000) {
                showWarningAlert("Invalid symbolrate.")
                return
            }
            if (adapter.symbolrate > 50000) {
                showWarningAlert("Invalid symbolrate.")
                return
            }
            if (adapter.symbolrate < 1000) {
                showWarningAlert("Invalid symbolrate.")
                return
            }
            if (adapter.symbolrate === "") {
                showWarningAlert("Invalid symbolrate.")
                return
            }
            let response = await adapterConfig([adapter]);
            if (response.status === 500) {
                showErrorAlert("Error: Internal server error.")
            }
            if (response.status === 401) {
                window.location.href = "/login";
            }
            if (response.status === 400) {
                showErrorAlert("Error in form data.")
            }
            else if (response.status === 200) {
                setLockedUi(true);
                setEditedAdapters([]);
                showSuccessAlert("Saved.")
                setAdapters((prevAdapters) =>
                    prevAdapters.map((prevAdapter) =>
                        prevAdapter.id === adapter.id
                            ? { ...prevAdapter, lockedUi: true }
                            : prevAdapter
                    )
                );

            }
        } else {
            showWarningAlert("Invalid BISS-key. Format: XXXXXX00XXXXXX00")
        }
    };
    const handleApplyPNR = async (adapter, pnr) => {
        if (validateBISSKey(adapter.streams[0].bissKey)) {
            adapter.streams[0].pnr = pnr
            let response = await adapterConfig([adapter]);
            if (response.status === 500) {
                showErrorAlert("Internal server error.")
            }
            if (response.status === 401) {
                window.location.href = "/login";
            }
            if (response.status === 400) {
                showErrorAlert("Error in form data")
            }
            else if (response.status === 200) {
                setLockedUi(true);
                setEditedAdapters([]);
                showSuccessAlert("Saved")
                setAdapters((prevAdapters) =>
                    prevAdapters.map((prevAdapter) =>
                        prevAdapter.id === adapter.id
                            ? { ...prevAdapter, lockedUi: true, scanShown: false, scanResults: undefined }
                            : prevAdapter
                    )
                );

            }
        } else {
            showWarningAlert("Invalid BISS-key. Format: XXXXXX00XXXXXX00")
        }

    }
    const handleChangeAdapterField = (adapterId, field, value) => {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId ? { ...adapter, [field]: value } : adapter
            )
        );
    };
    const handleChangeBissKey = (adapterId, value) => {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId ? { ...adapter, streams: adapter.streams.map((stream, index) => index === 0 ? { ...stream, bissKey: value } : stream), } : adapter));
    };
    const handleChangePNR = (adapterId, value) => {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId ? { ...adapter, streams: adapter.streams.map((stream, index) => index === 0 ? { ...stream, pnr: value.length > 0 ? parseInt(value) : "" } : stream), } : adapter))
    }
    const handleChangeFrequency = (adapterId, value) => {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId ? { ...adapter, frequency: value, } : adapter
            )
        );
    };
    const handleChangeSymbolRate = (adapterId, value) => {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId ? { ...adapter, symbolrate: value, } : adapter
            )
        );
    }
    const handleChangePolarization = (adapterId, value) => {
        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId ? { ...adapter, polarization: value, } : adapter
            )
        );

    }
    const handleDecodeTranspoder = (adapterId, value) => {
        setAdapters((prevAdapters) => prevAdapters.map((adapter) => adapter.id === adapterId ? { ...adapter, decodeTransponder: value } : adapter))
    }
    const handleShowScan = (adapterId, sid) => {
        setAdapters((prevAdapters) => prevAdapters.map((adapter) => adapter.id === adapterId ? { ...adapter, scanShown: true, scanResults: { loaded: false, step: "pending" } } : adapter))
    }
    const handleCancelScan = (adapterId) => {
        setAdapters((prevAdapters) => prevAdapters.map((adapter) => adapter.id === adapterId ? { ...adapter, scanShown: false } : adapter))
    }
    const showSuccessAlert = (message) => {
        StatusAlertService.showSuccess(message)
    }
    const showErrorAlert = (message) => {
        StatusAlertService.showError(message)
    }
    const showWarningAlert = (message) => {
        StatusAlertService.showWarning(message)
    }
    function validateBISSKey(input) {
        const pattern = /^[a-zA-Z0-9]{6}00[a-zA-Z0-9]{6}00$/;
        return pattern.test(input);
    }
    const handleStartScan = async (adapterId,sid) => {
        console.log("Start scan on adapter: " + adapterId + " sid: " + sid)
        await getScanResults(adapterId,sid)
    }
    const handlePnrClick = (adapterId, program) => {

        setAdapters((prevAdapters) =>
            prevAdapters.map((adapter) =>
                adapter.id === adapterId
                    ? {
                        ...adapter,
                        scanResults: {
                            ...adapter.scanResults,
                            data: adapter.scanResults.data.map((prgm) =>
                                prgm.pnr === program.pnr
                                    ? { ...prgm, selected: !prgm.selected }
                                    : { ...prgm, selected: false }
                            ),
                        },
                    }
                    : adapter
            )
        );

        // setScanResults((prev) => ({
        //     ...prev,
        //     data: prev.data.map((prgm) =>
        //         prgm.pnr === program.pnr
        //             ? { ...prgm, selected: !prgm.selected }
        //             : { ...prgm, selected: false }
        //     ),
        // }));
    };
    return (
        <div className="page-wrapper">

            <div className="background">
                {Array.from({ length: 40 }, (_, i) => (
                    <span key={i}></span>
                ))}
            </div>
            <Sidebar />

            <div className="content-wrapper">

                {isAdaptersLoaded ? (
                    <>
                        {adapters.map((adapter) => (
                            <div key={adapter.id} className="adapter-wrapper">

                                <div className="header-wrapper sat-delivery-bg">
                                    {adapter.name} Status:

                                    <div
                                        style={{ backgroundColor: `${adapter.lock === 1 ? "green" : "darkred"}` }}
                                        className={`pulse-base pulse-circle ${adapter.isPulsating ? 'pulse-anim' : ''}`}
                                    >
                                    </div>
                                </div>
                                <div className="body-wrapper">
                                    <div className="stream-info">
                                        <div className="column"
                                            style={{
                                                width: "100%",
                                            }}>
                                            <div className="row"
                                                style={{
                                                    width: "100%",
                                                }}
                                            >
                                                <div className="player-wrapper">
                                                    <div id={adapter.id}></div>
                                                </div>
                                            </div>

                                        </div>
                                        {!adapter.scanShown ? (
                                            <div className="column"
                                                style={{
                                                    width: "100%",
                                                    paddingTop: "14px"
                                                }}
                                            >
                                                <div className="row">
                                                    <div className="stream-info-with-tip">
                                                        <div className="stream-info-with-tip">
                                                            <label className="stream-info-tip">Frequency, MHz</label>
                                                            {adapter.lockedUi ? (
                                                                <span
                                                                    className="stream-info-data inter-regular">{adapter.frequency != null ? adapter.frequency : ""}</span>
                                                            ) : (
                                                                <input
                                                                    className="adapter-input-field inter-regular"
                                                                    name="frequency"
                                                                    type="number"
                                                                    value={`${adapter.frequency != null ? adapter.frequency : ""}`}
                                                                    onChange={(e) =>
                                                                        handleChangeFrequency(adapter.id, e.target.value)
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="stream-info-with-tip">
                                                        <label className="stream-info-tip">Polarization</label>
                                                        {adapter.lockedUi ? (
                                                            <div className="polarization-selector ">
                                                                {polarizationOptions.map((option, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className={`polarization-option inter-regular ${adapter.polarization === option.label ? 'active' : ''}`}

                                                                    >
                                                                        {option.label}
                                                                    </div>
                                                                ))}
                                                            </div>

                                                        ) : (

                                                            <div className="polarization-selector">
                                                                {polarizationOptions.map((option, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className={`polarization-option inter-regular ${adapter.polarization === option.label ? 'active' : ''}`}
                                                                        onClick={() => handleChangePolarization(adapter.id, option.label)}
                                                                    >
                                                                        {option.label}
                                                                    </div>
                                                                ))}
                                                            </div>

                                                        )}
                                                    </div>
                                                    <div className="stream-info-with-tip">
                                                        <div className="stream-info-with-tip">
                                                            <label className="stream-info-tip">Symbolrate, Kbaud</label>
                                                            {adapter.lockedUi ? (
                                                                <span
                                                                    className="stream-info-data inter-regular">{adapter.symbolrate != null ? adapter.symbolrate : ""}</span>
                                                            ) : (
                                                                <input
                                                                    className="adapter-input-field inter-regular"
                                                                    name="symbolrate"
                                                                    type="number"
                                                                    value={`${adapter.symbolrate != null ? adapter.symbolrate : ""}`}
                                                                    onChange={(e) =>
                                                                        handleChangeSymbolRate(adapter.id, e.target.value)
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="stream-info-with-tip">
                                                        <label className="stream-info-tip">BISS-Key</label>
                                                        {adapter.lockedUi ? (
                                                            <span
                                                                className="stream-info-data inter-regular">{adapter.streams != null ? adapter.streams[0].bissKey : ""}</span>
                                                        ) : (
                                                            <input
                                                                className="adapter-input-field inter-regular"
                                                                name="bissKey"
                                                                value={`${adapter.streams != null ? adapter.streams[0].bissKey : ""}`}
                                                                onChange={(e) =>
                                                                    handleChangeBissKey(adapter.id, e.target.value)
                                                                }
                                                            />
                                                        )}
                                                    </div>

                                                    <div className="stream-info-with-tip">
                                                        <label className="stream-info-tip">PNR(SID)</label>
                                                        {adapter.lockedUi ? (
                                                            <span
                                                                className="stream-info-data inter-regular">{adapter.streams != null ? adapter.streams[0].pnr : ""}</span>
                                                        ) : (
                                                            <input
                                                                className="adapter-input-field inter-regular"
                                                                name="pnr"
                                                                value={`${adapter.streams != null ? adapter.streams[0].pnr : 1}`}
                                                                onChange={(e) =>
                                                                    handleChangePNR(adapter.id, e.target.value)
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="stream-info-with-tip">
                                                        <label className="stream-info-tip">
                                                            Multicast
                                                        </label>
                                                        <span className="stream-info-data inter-regular">
                                                            {adapter.mcastOut}
                                                        </span>
                                                    </div>
                                                    <div className="stream-info-with-tip">
                                                        <label className="stream-info-tip " >
                                                            SRT-link
                                                        </label>
                                                        <span className="stream-info-data inter-regular">
                                                            {adapter.streams[0].SRTOutput}
                                                        </span>
                                                    </div>

                                                </div>
                                                <div className="row checkbox-wrapper">
                                                    {adapter.lockedUi ? (
                                                        <>
                                                            <input
                                                                id="decodeEntireFrequency"
                                                                type="checkbox"
                                                                value={adapter.decodeTransponder}
                                                                checked={adapter.decodeTransponder}


                                                            />
                                                            <label htmlFor="decodeEntireFrequency" className="inter-regular">
                                                                Decode whole frequency
                                                            </label>
                                                        </>

                                                    ) : (
                                                        <>
                                                            <input
                                                                id="decodeEntireFrequency"
                                                                type="checkbox"
                                                                value={adapter.decodeTransponder}
                                                                checked={adapter.decodeTransponder}
                                                                onChange={(e) => handleDecodeTranspoder(adapter.id, e.target.checked)}
                                                            />
                                                            <label htmlFor="decodeEntireFrequency" className="inter-regular">
                                                                Decode whole frequency
                                                            </label>
                                                        </>

                                                    )}

                                                </div>
                                                <div className="row controls-wrapper">
                                                    <div className="scan-button wide">
                                                        <div className="signal-status ">
                                                            <div className="row space-between ">
                                                                <span>
                                                                    Signal status:
                                                                </span>
                                                                {adapter.streams[0].onair ? (
                                                                    <span className="green">
                                                                        Active
                                                                    </span>
                                                                ) : (
                                                                    <span className="red">
                                                                        Inactive
                                                                    </span>
                                                                )}

                                                            </div>
                                                            <div className="row space-between ">
                                                                <span>
                                                                    Scrambled:
                                                                </span>
                                                                {adapter.streams[0].scrambled ? (
                                                                    <span className="red">
                                                                        Yes
                                                                    </span>
                                                                ) : (
                                                                    <span className="green">
                                                                        No
                                                                    </span>
                                                                )}

                                                            </div>
                                                            <div className="row space-between ">
                                                                <span>
                                                                    Bitrate:
                                                                </span>
                                                                {adapter.streams[0].bitrate > 100 ? (
                                                                    <span className="green">
                                                                        {adapter.streams[0].bitrate}Kb/s
                                                                    </span>
                                                                ) : (
                                                                    <span className="red">
                                                                        {adapter.streams[0].bitrate}Kb/s
                                                                    </span>
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    {adapter.lock ? (
                                                        <div

                                                            className="scan-button"
                                                            onClick={() => handleShowScan(adapter.id, adapter.sid)}
                                                        >
                                                            <img
                                                                src={satDish}
                                                            />
                                                            <span>SCAN</span>
                                                        </div>

                                                    ) : (
                                                        <div

                                                            className="scan-button deactivated"
                                                        >
                                                            <img
                                                                src={satDish}
                                                            />
                                                            <span>SCAN</span>
                                                        </div>
                                                    )}


                                                </div>
                                            </div>
                                        ) : (
                                            <div className="column" style={{ width: "100%", position: "relative", gap: "16px" }}>
                                                <span className="scan-heading">
                                                    {adapter.scanResults.step == "done" && (
                                                        <>
                                                           Programs on frequency {adapter.frequency}Mhz:
                                                        </>
                                                    )}
                                                    {adapter.scanResults.step == "pending" && (
                                                        <>
                                                            Start scanning {adapter.name} on frequency {adapter.frequency}Mhz?
                                                        </>
                                                    )}
                                                    {adapter.scanResults.step == "scanning" && (
                                                        <>
                                                            Scanning frequency {adapter.frequency}Mhz...
                                                        </>
                                                    )}
                                                </span>
                                                {adapter.scanResults.loaded && adapter.scanResults.data != undefined ? (
                                                    <div className="scan-result">
                                                        <>
                                                            {adapter.scanResults.data.map((program) => (
                                                                <div className="scan-program"
                                                                    style={{
                                                                        paddingTop: '24px'

                                                                    }}

                                                                    onClick={() => handlePnrClick(adapter.id, program)}
                                                                >
                                                                    <div className="stream-info-with-tip min-width-140  height-auto"
                                                                    >
                                                                        <label className="stream-info-tip top-8 " >
                                                                            PNR
                                                                        </label>
                                                                        <span className="stream-info-data inter-regular">
                                                                            {program.pnr}
                                                                        </span>
                                                                    </div>
                                                                    <div className="stream-info-with-tip min-width-140  height-auto">
                                                                        <label className="stream-info-tip top-8 " >
                                                                            Service name
                                                                        </label>
                                                                        <span className="stream-info-data inter-regular">
                                                                            {program.name}
                                                                        </span>
                                                                    </div>
                                                                    <input
                                                                        id="pnrCheckbox"
                                                                        type="checkbox"
                                                                        checked={program.selected}
                                                                    />

                                                                </div>
                                                            ))}
                                                        </>
                                                    </div>) : null}

                                                {!adapter.scanResults.loaded && adapter.scanResults.step == "scanning" && (
                                                    <div className="sat-loader-wrapper">

                                                        <div className="sat-loader"></div>
                                                    </div>


                                                )}
                                                {adapter.scanResults.step == "done" ? (
                                                    <div className="row pnr-controlls">
                                                        <div
                                                            onClick={() => handleCancelScan(adapter.id)}
                                                        >
                                                            Back
                                                        </div>
                                                        {adapter.scanResults.data.some(prgm => prgm.selected) ? (
                                                            <div onClick={() => handleApplyPNR(adapter, adapter.scanResults.data.find(prgm => prgm.selected)?.pnr)}>
                                                                Apply
                                                            </div>
                                                        ) : (
                                                            <div className='deactivated'>
                                                                Apply
                                                            </div>
                                                        )}

                                                    </div>

                                                ) : null}
                                                {adapter.scanShown && adapter.scanResults.step == "pending" && (
                                                    <div className="row justify-center scan-controls"
                                                        style={{
                                                            gap: "16px",
                                                            marginTop: "100px"
                                                        }}
                                                    >
                                                        <div
                                                            onClick={() => handleCancelScan(adapter.id)}
                                                        >
                                                            <img
                                                                style={{
                                                                    transform: "rotate(90deg)",
                                                                    left: "25px",
                                                                }}
                                                                src={arrow}
                                                            />
                                                            Back

                                                        </div>
                                                        <div
                                                            onClick={() => handleStartScan(adapter.id, adapter.sid)}
                                                        >
                                                            <img
                                                                src={satDish}
                                                            />
                                                            Scan
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                    </div>

                                    {!scanShown ? (
                                        <>
                                            {adapter.lockedUi ? (
                                                <img
                                                    className="icon-lock"
                                                    src={lock}
                                                    onClick={() => handleUnlockUI(adapter.id)}
                                                />
                                            ) : (
                                                <img
                                                    className="icon-lock"
                                                    src={unlock}
                                                    onClick={() => handleLockUI(adapter.id)}
                                                />
                                            )}
                                            {!adapter.lockedUi && (
                                                <div className="btn-save"

                                                    onClick={() => handleSave(adapter)}
                                                >
                                                    Save changes
                                                </div>
                                            )}
                                        </>
                                    ) : null}

                                </div>
                            </div>
                        ))}

                    </>
                ) : null}

            </div>
            <StatusAlert />
        </div>
    );
}

export default Home;

